import { MuPowerEditableLayerIds, MuPowerSolverLayerIds } from "fond/types/layer";

import { ValidationFunction } from "./GenericValidator";
import { makeValidateDemand, makeValidateLeadIn, makeValidateUgPath, makeValidateUgPoint } from "./undergroundValidation";

export const validateMuPowerDemand = makeValidateDemand({ leadinsLayerId: MuPowerEditableLayerIds.leadins });

export const validateMuPowerUgPath = makeValidateUgPath({ ugPointsLayerId: MuPowerEditableLayerIds.ugPoints });

export const validateMuPowerUgPoint = makeValidateUgPoint({
  ugPathLayerId: MuPowerEditableLayerIds.ugPath,
  leadinsLayerId: MuPowerEditableLayerIds.leadins,
});

export const validateMuPowerLeadIn = makeValidateLeadIn({
  demandLayerId: MuPowerEditableLayerIds.demand,
  ugPointsLayerId: MuPowerEditableLayerIds.ugPoints,
});

/**
 * A transformer-hub is valid if it is a Point, colocated with a ugPoint, and
 * not colocated with a source hub.
 */
export const validateTransformerHub: ValidationFunction = (feature, _allFeatures, helpers) => {
  const featureId = feature.id as string;
  const errors: string[] = [];

  if (feature.geometry.type !== "Point") {
    return { featureId, valid: false, errors: ["Transformer must be a Point feature"] };
  }

  const position = feature.geometry.coordinates;

  if (helpers.findFeaturesAtPosition(position, MuPowerEditableLayerIds.ugPoints).length === 0) {
    errors.push("Transformer must be colocated with a ugPoint");
  }

  // The 'spud_solver' used from MU_POWER solves will ignore any transformer hubs that are colocated with
  // source hubs, so don't allow that placement in the first place.
  if (helpers.findFeaturesAtPosition(position, MuPowerSolverLayerIds.sourceHubs).length > 0) {
    errors.push("Transformer cannot be placed on a source hub");
  }

  return { featureId, valid: errors.length === 0, errors };
};
